import React from "react";

const TripMeterStoppedBadge = ({ className = "" }) => (
  <span
    className={`font-UbuntuMedium text-red-600 ${className}`.trim()}
    title="Meter sensor issue — meter stopped"
  >
    Meter stopped
  </span>
);

const TripMeterWorkingBadge = ({ className = "" }) => (
  <span
    className={`font-UbuntuMedium text-green-700 ${className}`.trim()}
    title="Meter sensor OK"
  >
    Working
  </span>
);

/** Red text when stopped (is_meter_sensor_issue === 1), green Working when OK. */
const TripMeterStatusBadge = ({ stopped, className = "" }) =>
  stopped ? (
    <TripMeterStoppedBadge className={className} />
  ) : (
    <TripMeterWorkingBadge className={className} />
  );

export default TripMeterStatusBadge;
export { TripMeterStoppedBadge, TripMeterWorkingBadge };
